import React, { useState, useRef, useEffect } from "react";
import { Trans, useTranslation } from "react-i18next";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import PropTypes from "prop-types";
import { Row, Col, Form, Space, Input, Spin, Button } from "antd";
import {
  MinusSquareFilled,
  PlusSquareFilled,
  SaveOutlined,
} from "@ant-design/icons";
import "antd/dist/antd.min.css";
import "../../styles/Main.scss";
import { getRequest, patchRequest } from "../../axios";
import {
  ErrorNotificationMsg,
  SuccessNotificationMsg,
} from "../../utils/Notifications";
import ButtonField from "../../common/htmlComponents/ButtonField";
import { authUserData } from "../../utils/Helper";

const WhomToIntimateVendor = ({
  VendorId,
  paymentReleasedId,
  setPaymentReleasedId,
  gstVendorId,
  gstValue,
}) => {
  const formRef = useRef();
  const { t } = useTranslation();

  // const VendorId = id ? atob(id) : null;
  const initialState = {
    payment_released: [
      {
        person_name: null,
        email: null,
        designation: null,
        contact_number: null,
        department: null,
      },
    ],
  };
  const [state, setState] = useState(initialState);
  const [btnLoading, setBtnLoading] = useState(false);

  const [apiLoading, setapiloading] = useState(false);

  const handleCloneInputChange = (field, e, index) => {
    let newPersonArr = state.payment_released;
    newPersonArr[index][field] = e.target.value ? e.target.value : null;
    setState({ ...state, payment_released: newPersonArr });
  };
  const removePerson = async (lastIndex) => {
    let filterPersonArr = state.payment_released.filter(
      (item, index) => index !== lastIndex
    );
    setState({ ...state, payment_released: filterPersonArr });
    setWeightSizeFieldValue(filterPersonArr);
  };
  // const CompanyId = authUserData()?.company ? authUserData()?.company : null;

  const setWeightSizeFieldValue = (data) => {
    let stateArr = [];
    let fieldObject = {};
    console.log(data);
    data.map((objectValue, objectKey) => {
      stateArr.push(objectValue);
      fieldObject["person_name" + objectKey] = objectValue.person_name;
      fieldObject["email" + objectKey] = objectValue.email;
      fieldObject["department" + objectKey] = objectValue.department;
      fieldObject["designation" + objectKey] = objectValue.designation;
      fieldObject["contact_number" + objectKey] = String(
        objectValue.contact_number || "+91"
      );
      return null;
    });
    formRef.current.setFieldsValue(fieldObject);
  };
  const addPerson = () => {
    let newPersonArr = [
      ...state.payment_released,
      {
        person_name: null,
        email: null,
        designation: null,
        contact_number: null,
        department: null,
      },
    ];
    setState({ ...state, payment_released: newPersonArr });
    setWeightSizeFieldValue(newPersonArr);
  };
  const handleClonePhoneInputChange = (field, phone, index) => {
    let newPersonArr = state.payment_released;
    newPersonArr[index][field] = phone ? phone : null;
    setState({ ...state, payment_released: newPersonArr });
  };

  // const phoneValidLength = state.phone;

  // const validatePhoneNumber = () => {
  //   if (
  //     (phoneValidLength && phoneValidLength.length < 12) ||
  //     phoneValidLength === null ||
  //     phoneValidLength === ""
  //   ) {
  //     return Promise.reject(new Error(t("please_enter_valid_phone")));
  //   }

  //   return Promise.resolve();
  // };

  useEffect(() => {
    const getVendorOnboarding = async () => {
      setapiloading(true);
      try {
        // const vendor = gstVendorId ? gstVendorId : VendorId;
        const apiResponse = await getRequest(
          // `vendor/${VendorId}/get-vendor-payment-terms/${CompanyId}/`
          `vendor-payment-released/?vendor=${1}`
        );
        console.log("apiResponse", apiResponse);

        if (apiResponse.data.success) {
          // const {
          //   //   unique_code,
          //   id,
          //   //   company_payment_terms,
          //   ...filteredResponse
          // } = apiResponse.data.data;
          if (apiResponse.data.success) {
            setState({
              // ...filteredResponse,

              payment_released: apiResponse.data.data.map((keyPerson) => {
                const { vendor, vendor_name, company_name, ...rest } =
                  keyPerson;
                return rest;
              }),
            });

            const modifiedKeypersons = apiResponse.data.data.map(
              (keypersonDetail) => {
                const { id, vendor, vendor_name, ...rest } = keypersonDetail;
                return rest;
              }
            );
            setWeightSizeFieldValue(modifiedKeypersons);

            if (VendorId !== null) {
              // setIsGstNoReadOnly(true);
            }
          }
        } else {
          // ErrorNotificationMsg(t("err_getSubscription"));
        }
        setapiloading(false);
      } catch (error) {
        setapiloading(false);
      }
    };

    const getGstVendorOnboarding = async () => {
      setapiloading(true);
      try {
        const apiResponse = await getRequest(
          // `vendor/${VendorId}/get-vendor-payment-terms/${CompanyId}/`
          // `vendor-payment_released/?vendor=${VendorId}`
          `vendor-payment-released/payment-released-by-gst/?gst_no=${gstValue}`
        );
        console.log("apiResponse112 ", apiResponse);
        // if (apiResponse.data.success) {
        // const {
        //   //   unique_code,
        //   id,
        //   //   company_payment_terms,
        //   ...filteredResponse
        // } = apiResponse.data.data;
        if (apiResponse.data.success) {
          setState({
            // ...filteredResponse,

            payment_released: apiResponse.data.data.map((keyPerson) => {
              const { vendor, vendor_name, company_name, ...rest } = keyPerson;
              return rest;
            }),
          });

          const modifiedKeypersons = apiResponse.data.data.map(
            (keypersonDetail) => {
              const { id, vendor, vendor_name, ...rest } = keypersonDetail;
              return rest;
            }
          );
          setWeightSizeFieldValue(modifiedKeypersons);

          if (VendorId !== null) {
            // setIsGstNoReadOnly(true);
          }
        }
        if (apiResponse.data.success) {
          console.log(apiResponse);
          setPaymentReleasedId(apiResponse?.data?.data[0]?.id);
          setState({
            // ...filteredResponse,

            payment_released: apiResponse.data.data.map((keyPerson) => {
              const { vendor, vendor_name, company_name, ...rest } = keyPerson;
              return rest;
            }),
          });

          const modifiedKeypersons = apiResponse.data.data.map(
            (keypersonDetail) => {
              const { vendor, vendor_name, ...rest } = keypersonDetail;
              return rest;
            }
          );
          setWeightSizeFieldValue(modifiedKeypersons);

          if (VendorId !== null) {
            //setIsGstNoReadOnly(true);
          }
        } else if (apiResponse.data.success === false) {
          console.log(apiResponse);
          setState({
            // ...filteredResponse,

            payment_released: apiResponse.data.data.map((keyPerson) => {
              const { vendor, vendor_name, company_name, ...rest } = keyPerson;
              return rest;
            }),
          });

          const modifiedKeypersons = apiResponse.data.data.map(
            (keypersonDetail) => {
              const { vendor, vendor_name, ...rest } = keypersonDetail;
              return rest;
            }
          );
          setWeightSizeFieldValue(modifiedKeypersons);
          setPaymentReleasedId(null);
          if (VendorId !== null) {
            //setIsGstNoReadOnly(true);
          }
        }
        // }
        else {
          // ErrorNotificationMsg(t("err_getSubscription"));
        }
        setapiloading(false);
      } catch (error) {
        setapiloading(false);
      }
    };
    // if (VendorId !== null) {
    //   // if (paymentReleasedId !== null) {
    //   getVendorOnboarding();
    // }
    if (VendorId !== null && gstVendorId === null) {
      // if (paymentReleasedId !== null) {
      getVendorOnboarding();
    }
    if (gstVendorId !== null) {
      getGstVendorOnboarding();
    }
  }, [VendorId]);

  const handleSubmit = async () => {
    console.log("22 ");

    const payload = {
      payment_released:
        state.payment_released &&
        state.payment_released.every(
          (person) =>
            person.person_name === null &&
            person.email === null &&
            person.designation === null &&
            person.contact_number === null &&
            person.department === null
        )
          ? // company: CompanyId
            []
          : state.payment_released,
    };
    try {
      setBtnLoading(true);

      let response;

      console.log("san");

      if (paymentReleasedId === null) {
        console.log("abc 2");

        const url =
          VendorId !== null
            ? `vendor-payment-released/${VendorId}/add-payment-released/`
            : `vendor-payment-released/${gstVendorId}/add-payment-released/`;

        // response = await patchRequest(
        //   `vendor-payment_released/${VendorId}/add-payment_released/`,
        //   payload
        // );
        response = await patchRequest(url, payload);
        console.log("hsdhs");
      } else {
        console.log("11");
        const url =
          VendorId !== null
            ? `vendor-payment-released/${VendorId}/`
            : `vendor-payment-released/${gstVendorId}/`;

        response = await patchRequest(url, payload);
        console.log(response, "abcds");
        // response = await patchRequest(
        //   `vendor-payment_released/${VendorId}/`,
        //   payload
        // );
      }
      console.log("abcs 3");

      if (response.data.success) {
        // setState(response.data.data.payment_released)
        console.log("abc 4");
        SuccessNotificationMsg(
          paymentReleasedId === null
            ? t("payment_terms_added_successfully")
            : t("payment_terms_updated_successfully")
        );

        setState({
          // ...filteredResponse,

          payment_released: response.data.data.payment_released.map(
            (keyPerson) => {
              const { vendor, vendor_name, company_name, ...rest } = keyPerson;
              return rest;
            }
          ),
        });

        const modifiedKeypersons = response.data.data.payment_released.map(
          (keypersonDetail) => {
            const { vendor, vendor_name, ...rest } = keypersonDetail;
            return rest;
          }
        );
        setWeightSizeFieldValue(modifiedKeypersons);

        // paymentReleasedId();
        console.log(response.data.data.payment_released[0].id);
        setPaymentReleasedId(response.data.data.payment_released[0].id);

        // setState(initialState);
        // formRef.current.setFieldsValue(initialState);
        setBtnLoading(false);
        //navigate("/employee");
      }
    } catch (error) {
      //ErrorNotificationMsg();
      VendorId === null
        ? t("error_in_adding_keyperson")
        : t("error_in_updating_keyperson");
      setBtnLoading(false);
    }
  };

  return (
    <>
      <Spin spinning={apiLoading}>
        <Form autoComplete="off" ref={formRef}>
          {state.payment_released &&
            state.payment_released.map((x, index) => {
              return (
                <>
                  <Row key={index} className="customcol" gutter={[15]}>
                    <Col
                      xs={24}
                      sm={24}
                      md={12}
                      lg={4}
                      xl={4}
                      className="TextFeild gutter-row"
                    >
                      <Form.Item
                        name={`person_name` + index}
                        label={t("pl_personName")}
                        // rules={[
                        //   {
                        //     min: 3,
                        //     message: <Trans>{t("minlength_msg")}</Trans>,
                        //   },
                        //   {
                        //     max: 30,
                        //     message: (
                        //       <Trans>{t("maxlength_personName")}</Trans>
                        //     ),
                        //   },
                        // ]}
                        rules={[
                          {
                            required: true,
                            message: <Trans>{t("Enter Valid Name")}</Trans>,
                          },
                          {
                            pattern: /^[a-zA-Z_ ]+$/,
                            message: "Enter Valid Name",
                          },
                          {
                            min: 2,
                            message: <Trans>{t("minlength_msg")}</Trans>,
                          },
                          {
                            max: 15,
                            message: <Trans>{t("maxlength_personName")}</Trans>,
                          },
                        ]}
                      >
                        <Input
                          className="cust-input"
                          placeholder={t("pl_personName")}
                          onChange={(value) =>
                            handleCloneInputChange("person_name", value, index)
                          }
                        />
                      </Form.Item>
                    </Col>
                    <Col
                      xs={24}
                      sm={24}
                      md={12}
                      lg={4}
                      xl={4}
                      className="TextFeild gutter-row"
                    >
                      <Form.Item
                        name={`designation` + index}
                        label={t("lbb_designation")}
                        rules={[
                          {
                            required: true,
                            message: <Trans>{t("Please Enter Valid Designation")}</Trans>,
                          },
                          {
                            min: 3,
                            message: <Trans>{t("minlength_msg")}</Trans>,
                          },
                          {
                            max: 30,
                            message: (
                              <Trans>{t("maxlength_designation")}</Trans>
                            ),
                          },
                        ]}
                      >
                        <Input
                          className="cust-input"
                          placeholder={t("pl_designation")}
                          onChange={(value) =>
                            handleCloneInputChange("designation", value, index)
                          }
                        />
                      </Form.Item>
                    </Col>
                    <Col
                      xs={24}
                      sm={24}
                      md={12}
                      lg={4}
                      xl={4}
                      className="TextFeild gutter-row"
                    >
                      <Form.Item
                        name={`department` + index}
                        label={t("pl_department")}
                        rules={[
                          {
                            required: true,
                            message: <Trans>{t("Please Enter Valid Department")}</Trans>,
                          },
                          {
                            min: 3,
                            message: <Trans>{t("minlength_msg")}</Trans>,
                          },
                          {
                            max: 30,
                            message: (
                              <Trans>{t("maxlength_designation")}</Trans>
                            ),
                          },
                        ]}
                      >
                        <Input
                          className="cust-input"
                          placeholder={t("Enter Department")}
                          onChange={(value) =>
                            handleCloneInputChange("department", value, index)
                          }
                        />
                      </Form.Item>
                    </Col>
                    <Col
                      xs={24}
                      sm={24}
                      md={12}
                      lg={4}
                      xl={4}
                      className="TextFeild gutter-row"
                    >
                      <Form.Item
                        name={`email` + index}
                        label={t("lbb_email")}
                        rules={[
                          {
                            required: true,
                            message: <Trans>{t("Please Enter Valid Email")}</Trans>,
                          },
                          {
                            type: "email",
                            message: <Trans>{t("val_email")}</Trans>,
                          },
                        ]}
                      >
                        <Input
                          className="cust-input"
                          placeholder={t("pl_email")}
                          onChange={(value) =>
                            handleCloneInputChange("email", value, index)
                          }
                        />
                      </Form.Item>
                    </Col>
                    <Col xs={24} sm={24} md={12} lg={4} xl={4}>
                      <div className="verifywrap">
                        <Form.Item
                          name={`contact_number` + index}
                          label={t("pl_ContactNo")}
                          pattern={"/^d{12}$/"}
                          rules={[
                            {
                              required: true,
                              message: <Trans>{t("Please Enter Valid Contact No.")}</Trans>,
                            },
                            {
                              message: <Trans>{t("val_phone")}</Trans>,
                            },
                            {
                              pattern: /^\d{12}$/,
                              message: <Trans>{t("val_phone")}</Trans>,
                            },
                          ]}
                        >
                          <PhoneInput
                            className="PhoneSection"
                            country={"in"}
                            onChange={(phone) =>
                              handleClonePhoneInputChange(
                                "contact_number",
                                phone,
                                index
                              )
                            }
                          />
                        </Form.Item>
                      </div>
                    </Col>
                    <Col xs={24} sm={24} md={12} lg={4} xl={4}>
                      <div className="addwrp">
                        <Space>
                          {index !== 0 ? (
                            <MinusSquareFilled
                              className="add"
                              onClick={() => removePerson(index)}
                            />
                          ) : (
                            ""
                          )}

                          <PlusSquareFilled
                            className="add"
                            onClick={(e) => addPerson(e)}
                          />
                        </Space>
                      </div>
                    </Col>
                  </Row>
                </>
              );
            })}
          {VendorId || gstVendorId ? (
            <div className="subbuttonsrow">
              {/* <ButtonField
                  type="primary"
                  className="CancelGradiantBtn"
                  htmlType="button"
                  label={t("cancel")}
                /> */}

              {/* <ButtonField
                type="primary"
                className="SaveGradiantBtn"
                // htmlType="Submit"
                onClick={handleSubmit}
                label={t("save")}
                loading={btnLoading}
              />
            </div>
          ) : (
            ""
          )}
        </Form>
      </Spin> */}
              <ButtonField
                type="primary"
                //className="primary"
                icon={<SaveOutlined />}
                onClick={handleSubmit}
                label={t("save")}
                loading={btnLoading}
              />
              {/* Save
                    </ButtonField> */}
            </div>
          ) : (
            ""
          )}
        </Form>
      </Spin>
    </>
  );
};
WhomToIntimateVendor.propTypes = {
  VendorId: PropTypes.number,
  paymentReleasedId: PropTypes.number,
  setPaymentReleasedId: PropTypes.func,
  gstVendorId: PropTypes.number,
  gstValue: PropTypes.number,
};
export default WhomToIntimateVendor;
